import React from 'react';

import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import Tooltip from '@atlaskit/tooltip';

const hasNonEmptyDescription = (value: string | null | undefined): boolean => {
	if (value == null || typeof value !== 'string') return false;
	// Treat whitespace-only (including \n, \t, etc.) as empty
	return !/^\s*$/.test(value);
};

export const PermissionDescriptionTooltip = ({ description }: { description?: string | null }) => {
	if (!hasNonEmptyDescription(description)) {
		return null;
	}
	return (
		<Tooltip position="right" content={description?.trim() ?? ''}>
			<StatusInformationIcon label="" size="small" />
		</Tooltip>
	);
};
